module.exports = "<!-- <div class=\"container\">\n  <div class=\"card-footer text-center\">© 2018 THE TOP</div>\n</div> -->\n\n<footer class=\"footer\">\n    THE TOP\n</footer>"


//////////////////
// WEBPACK FOOTER
// C:/Users/homePC/angular-comp/The-Top/src/app/core/footer/footer.component.html
// module id = ../../../../../src/app/core/footer/footer.component.html
// module chunks = main